@if (data) {
  <div
    (click)="isFlipCards ? toggleFlipCard() : null"
    (keyup.enter)="isFlipCards ? toggleFlipCard() : null"
    [class.card-open]="isCardToggled"
    [ngClass]="{
      'box-block--text': isDualBoxOverlay && !image && !video,
      'box-block--media': isDualBoxOverlay && (image || video),
      'box-block__full-width-bleed': allowBackgroundFullWidthBleed,
      'box-block__hidden': hideOnMobileColumn,
      'box-block__telephone-block': telephoneAvailabilityBlocks,
      'box-block__flip-card': isFlipCards,
      'box-block__author-card': profileImage
    }"
    class="box-block"
    role="group"
  >
    @if (
      (contentLayout === "full" && allowBackgroundFullWidthBleed) ||
      (contentLayout === "narrow" && allowBackgroundFullWidthBleed)
    ) {
      <div [class]="['background-panel', boxColour]"></div>
    }

    @if (isDualBoxOverlay && !image) {
      <div [class]="boxColour + ' box-block__image-overlay'"></div>
    }

    @if (!isClickableBox) {
      <div
        [class]="!isFlipCards ? boxColour : ''"
        [ngClass]="{
          'box-block__container box-shadow': true,
          'box-block--bottom': imageLocation,
          'box-block--column-content': isInColumnContentArea,
          'box-block__brand-icon-container':
            (brandIcon && contentLayout === 'full') ||
            (brandIcon && !isInColumnContentArea)
        }"
      >
        <ng-container [ngTemplateOutlet]="boxContent"></ng-container>
        @if (isFlipCards) {
          <div [class]="boxColour" class="box-block__content--back">
            <div class="box-block__wrapper">
              @if (brandIcon) {
                <div class="box-block__content--brand-icon">
                  <lg-brand-icon
                    [name]="brandIcon"
                    [colour]="brandIconAccentColourBack"
                    [halfToneColour]="brandIconColourBack"
                    [outlinesColour]="brandIconColourBack"
                  />
                </div>
              }
              <div
                [innerHTML]="body | safeHtml"
                [wysiwygContainer]="'Box Component'"
                class="box-block__body wysiwyg"
                dotcomFrontendWysiwyg
              ></div>
              @if (isFlipCards) {
                <div class="box-block__renew-icon-container">
                  <lg-icon [name]="'renew'" class="box-block__renew-icon" />
                </div>
              }
            </div>
          </div>
        }
      </div>
    } @else {
      <dotcom-frontend-link
        [class]="boxColour"
        [ngClass]="{
          'box-block__container box-shadow': true,
          'box-block--bottom': imageLocation,
          'box-block--column-content': isInColumnContentArea,
          'has-hover-shadow': !isParentBackgroundColourSet
        }"
        [url]="data && data['ctaButtons'][0].href"
      >
        <ng-container [ngTemplateOutlet]="boxContent"></ng-container>
      </dotcom-frontend-link>
    }
  </div>
}

<ng-template #boxContent>
  @if (profileImage) {
    <div>
      <dotcom-frontend-image
        [image]="profileImage"
        class="box-block__author-image"
      />
    </div>
  }

  @if (image || video) {
    <div class="box-block__content box-block__content--image">
      @if (image && !video && !isFlipCards) {
        <dotcom-frontend-image [image]="image" class="box-block__image" />
      }

      @if (videoBlock) {
        <dotcom-frontend-loader
          [componentData]="videoBlock"
          cssClass="box-block__video"
          parentSpacing="zero"
        />
      }
    </div>
  }

  @if (!image && brandIcon && !isFlipCards) {
    <div class="box-block__content box-block__content--brand-icon">
      <lg-brand-icon
        [name]="brandIcon"
        [colour]="brandIconAccentColour"
        [halfToneColour]="brandIconColour"
        [outlinesColour]="brandIconColour"
      ></lg-brand-icon>
    </div>
  }

  @if (
    (isDualBox || isDualBoxOverlay) && !image && !video
      ? true
      : isDualBox
        ? !isDualBox
        : !isDualBoxOverlay
  ) {
    <div class="box-block__content box-block__content--card">
      <div class="box-block__wrapper">
        @if (!isFlipCards) {
          <div class="box-block__tag">
            @if (tag) {
              <span class="box-block__tag box-block__tag--text">{{ tag }}</span>
              @if (icon) {
                <lg-icon
                  [name]="icon"
                  class="box-block__tag box-block__tag--icon"
                />
              }
            }
          </div>
        }

        @if (brandIcon && isFlipCards) {
          <div class="box-block__content--brand-icon">
            <lg-brand-icon
              [name]="brandIcon"
              [colour]="brandIconAccentColour"
              [halfToneColour]="brandIconColour"
              [outlinesColour]="brandIconColour"
            />
          </div>
        }

        @if (authorName) {
          <div
            class="author-card__name lg-font-size-3--medium lg-font--expressive"
          >
            {{ authorTitle }} {{ authorName }} {{ authorSurname }}
          </div>
        }

        @if (title) {
          @if (navigationBoxBlock) {
            <div
              class="box-block__title lg-font--expressive navigation-box-block"
            >
              {{ title }}
            </div>
          } @else {
            <h2 class="box-block__title lg-font--expressive">
              {{ title }}
            </h2>
          }
        }

        @if (subtitle) {
          @if (navigationBoxBlock) {
            <div class="box-block__subtitle navigation-box-block">
              {{ subtitle }}
            </div>
          } @else {
            <h3 class="box-block__subtitle">{{ subtitle }}</h3>
          }
        }

        @if (jobInformation) {
          <div class="author-card__job">
            <p>{{ jobInformation }}</p>
          </div>
        }

        @if (bio) {
          <div class="author-card__teaser-bio" [innerHTML]="bio"></div>
        }

        @if (!isFlipCards) {
          <div
            [innerHTML]="body | safeHtml"
            [wysiwygContainer]="'Box Component'"
            class="box-block__body wysiwyg"
            dotcomFrontendWysiwyg
          ></div>
        } @else {
          <div class="box-block__renew-icon-container">
            <lg-icon [name]="'renew'" class="box-block__renew-icon" />
          </div>
        }

        @if (telephoneAvailabilityBlocks) {
          <div class="box-block__telephone">
            @for (
              telephoneAvailabilityBlock of telephoneAvailabilityBlocks;
              let i = $index;
              track i
            ) {
              <div>
                <dotcom-frontend-loader
                  [componentData]="telephoneAvailabilityBlock"
                />
              </div>
            }
          </div>
        }

        @if (!isFlipCards) {
          <div class="box-block__footer">
            @if (readTime) {
              <div class="box-block__read-time">
                <lg-icon name="time" /> {{ readTime }} mins
              </div>
            }

            @if (ctaButtons) {
              @if (isLinkList) {
                <dotcom-frontend-loader [componentData]="ctaButtons" />
              } @else if (isQuickNav) {
                <dotcom-frontend-loader [componentData]="ctaButtons" />
              } @else if (isButtonAndLinkList) {
                @for (button of ctaButtons; let i = $index; track i) {
                  @if (i === 0) {
                    <dotcom-frontend-loader [componentData]="button" />
                  }
                  @if (i !== 0) {
                    <dotcom-frontend-loader [componentData]="linkListButtons" />
                  }
                }
              } @else if (isLinkListAndButton) {
                <dotcom-frontend-loader [componentData]="linkListButtons" />
                <dotcom-frontend-loader [componentData]="lastButton" />
              } @else {
                @for (button of ctaButtons; let i = $index; track i) {
                  <dotcom-frontend-loader [componentData]="button" />
                }
              }
            }
          </div>
        }
      </div>
    </div>
  }
</ng-template>
